import { render, staticRenderFns } from "./ParametersBoard.vue?vue&type=template&id=6cff63a4&scoped=true&"
import script from "./ParametersBoard.vue?vue&type=script&lang=js&"
export * from "./ParametersBoard.vue?vue&type=script&lang=js&"
import style0 from "./ParametersBoard.vue?vue&type=style&index=0&id=6cff63a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cff63a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cff63a4')) {
      api.createRecord('6cff63a4', component.options)
    } else {
      api.reload('6cff63a4', component.options)
    }
    module.hot.accept("./ParametersBoard.vue?vue&type=template&id=6cff63a4&scoped=true&", function () {
      api.rerender('6cff63a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/analyzes/ParametersBoard.vue"
export default component.exports